module.exports = __webpack_public_path__ + "static/media/remote.65579330.jpg";